//angular imports
import {
    ChangeDetectionStrategy,
    Component, 
    WritableSignal, 
    signal,
} from '@angular/core';

//local imports
import { PresenterType } from '@shared/components';
import { ProgramNotFoundMessage } from './program-not-found.message';

@PresenterType(
{
    model: ProgramNotFoundMessage
})
@Component({
    selector: 'program-not-found-message-template',
    templateUrl: './program-not-found-message-template.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProgramNotFoundMessageTemplateComponent
{
    public data: WritableSignal<ProgramNotFoundMessage>;
    
    constructor() {
        this.data = signal<ProgramNotFoundMessage>(null);
    }
}